module.exports = __webpack_public_path__ + "static/NHaasGroteskTXStd-75Bd-41dde56a21cbbcc6cd5cfb35fd39638a.woff2";